module.exports = __webpack_public_path__ + "static/media/maa.24604cad.jpg";